export default "__VITE_ASSET__BY5ZyT4h__"